<script setup lang="ts">
import type { ButtonProps } from '#ui/types';
import type { RouteLocationAsRelativeGeneric } from '#vue-router';

import { FE_PAGE_PARAM, FIRST_PAGE } from '~/constants/pagination';

// PROPS
export interface BasePaginationProps {
    page: number;
    itemsPerPage: number;
    total: number;
    disabled?: boolean;
    size?: ButtonProps['size'];
}

const { page, itemsPerPage, total, disabled = false } = defineProps<BasePaginationProps>();

// COMPOSABLES
const route = useRoute();

// METHODS
const formatRoute = (p: number): RouteLocationAsRelativeGeneric => ({
    query: { ...route.query, [FE_PAGE_PARAM]: p !== FIRST_PAGE ? p : undefined },
});

const onPageChange = (): void => scrollToTop();
</script>

<template>
    <UPagination
        :page="page"
        :items-per-page="itemsPerPage"
        :total="total"
        show-edges
        :size="size"
        :disabled="disabled"
        :to="formatRoute"
        variant="ghost"
        @update:page="onPageChange"
    >
        <template #first>
            <span />
        </template>
        <template #last>
            <span />
        </template>
    </UPagination>
</template>
